module.exports = __webpack_public_path__ + "static/media/Submitnew.a466c508.svg";